import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const PrivateRoute = () => {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    fetch('/privateZone/auth_status.php', { credentials: 'include' })
      .then(res => setAuth(res.ok))
      .catch(() => setAuth(false));
  }, []);

  if (auth === null) return null;
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
